const catData = [
  { name: "恋爱", icon: "ri-heart-3-line", count: 268, color: "bg-accent-100 text-accent-700" },
  { name: "奇幻", icon: "ri-sparkling-2-line", count: 196, color: "bg-primary-100 text-primary-700" },
  { name: "都市", icon: "ri-building-line", count: 152, color: "bg-secondary-100 text-secondary-800" },
  { name: "动作", icon: "ri-sword-line", count: 184, color: "bg-primary-100 text-primary-700" },
  { name: "悬疑", icon: "ri-focus-3-line", count: 121, color: "bg-accent-100 text-accent-700" },
  { name: "校园", icon: "ri-graduation-cap-line", count: 138, color: "bg-secondary-100 text-secondary-800" },
  { name: "科幻", icon: "ri-rocket-2-line", count: 97, color: "bg-primary-100 text-primary-700" },
  { name: "冒险", icon: "ri-compass-3-line", count: 143, color: "bg-accent-100 text-accent-700" },
];

export default function Categories() {
  return (
    <section id="categories" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-medium text-secondary-800">
              <i className="ri-grid-fill"></i>
              韩漫题材分类
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              按你喜欢的题材发现韩漫
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              从恋爱到科幻，从悬疑到冒险，韩漫在线全题材覆盖，高清画质持续更新，总有一部打动你。
            </p>
          </div>
          <a
            href="#showcase"
            className="whitespace-nowrap rounded-full border border-foreground-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-600"
          >
            浏览全部韩漫
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {catData.map((c) => (
            <a
              key={c.name}
              href="#showcase"
              className="group flex flex-col items-start gap-3 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-lg ${c.color}`}>
                <i className={c.icon}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950">{c.name}</h3>
                <p className="mt-1 text-xs text-foreground-500">{c.count} 部连载韩漫</p>
              </div>
              <i className="ri-arrow-right-up-line text-base text-foreground-300 transition-colors group-hover:text-primary-500"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}